import { OnboardingData } from 'api/types/data';
import {
  ClientAccountStatusType,
  OnboardingStatusType,
} from 'api/types/entity';
import { TFunc } from 'libs/i18n';
import { Chip, ChipProps, ChipVariant } from 'libs/ui';

import { getOnboardingProgressPercent } from '../getOnboardingProgressPercent';

interface ClientsListItem {
  status: OnboardingStatusType | ClientAccountStatusType;
  onboarding?: OnboardingData;
}

export const renderClientStatus = (
  item: ClientsListItem,
  t: TFunc,
  chipProps?: Partial<ChipProps>
) => {
  let variant: ChipVariant = 'blue';
  let text = t(`client.status.${item.status}`);

  switch (item.status) {
    case OnboardingStatusType.FillingOut:
      variant = 'blue';
      const percent = getOnboardingProgressPercent(item.onboarding);
      text += ` (${percent}%)`;
      break;

    case OnboardingStatusType.AwaitingAccountOpening:
      variant = 'purple';
      break;
    case OnboardingStatusType.SigningDocuments:
      variant = 'violet';
      break;
    case OnboardingStatusType.ComplianceCheck:
    case OnboardingStatusType.AmlCftCheck:
    case OnboardingStatusType.ValidationCheck:
    case OnboardingStatusType.BoardReview:
      variant = 'orange';
      break;
    case OnboardingStatusType.SigningQuestionnaire:
      variant = 'pink';
      break;
    case OnboardingStatusType.AwaitingComplianceCheck:
    case OnboardingStatusType.AwaitingAmlCftCheck:
    case OnboardingStatusType.AwaitingValidation:
    case OnboardingStatusType.PendingBoardReview:
    case OnboardingStatusType.AwaitingPaymentConfirmation:
    case ClientAccountStatusType.Frozen:
      variant = 'yellow';
      break;

    case OnboardingStatusType.AccountOpening:
      variant = 'turquoise';
      break;

    case OnboardingStatusType.AccountOpened:
    case ClientAccountStatusType.Opened:
      variant = 'green';
      break;

    case OnboardingStatusType.AccountOpeningDenied:
    case ClientAccountStatusType.ClosingInProgress:
    case ClientAccountStatusType.Closed:
      variant = 'red';
      break;

    default:
      variant = 'blue';
      break;
  }

  return (
    <Chip {...chipProps} size={chipProps?.size} text={text} variant={variant} />
  );
};
